import Request from 'admin/lib/adminRequest';

export default {
    list: async ({ query, id, pagination }) => {
        const { page, pageSize: limit } = pagination;
        try {
            const [pipelinesRes, selectedRes] = await Promise.all([
                Request.postJSON('admin/project/listPipelines', {
                    query,
                    limit,
                    page
                }),
                Request.postJSON('admin/project/listPipelines', {
                    id: id === undefined ? [] : id
                })
            ]);

            if (pipelinesRes.error || selectedRes.error) {
                throw new Error(pipelinesRes.msg || selectedRes.msg);
            }

            const pipelines = { data: pipelinesRes.data, count: pipelinesRes.count };
            const selected = { data: selectedRes.data };

            selected.data.forEach(itemSelected => {
                const item = pipelines.data.find(
                    itemPipeline => itemPipeline.id === itemSelected.id
                );
                if (!item) {
                    pipelines.data.push({
                        ...itemSelected,
                        missingSelected: true
                    });
                }
            });

            return pipelines;
        } catch (err) {
            console.error(err);
        }
    },
    listPipelineType: () => {
        const pipelineType = [
            { id: '-', name: '-' },
            { id: 'promote', name: _('Promote') },
            { id: 'demote', name: _('Demote') },
            { id: 'static', name: _('Static') }
        ];

        return {
            data: pipelineType,
            count: pipelineType.length
        };
    }
};
